import request from "../utils/axios";

export const getTerminals = (params) => {
  return request({ method: "GET", url: "/terminals", params });
};

export const createTerminal = (data) => {
  return request({ method: "POST", url: "/terminals", data });
};

export const editTerminal = (id, data) => {
  return request({ method: "PUT", url: `/terminals/${id}`, data });
};

export const deleteTerminal = (id) => {
  return request({ method: "DELETE", url: `/terminals/${id}` });
};
